import * as Yup from 'yup';
import { StepMainFacilityForm } from './step-main-facility-types';

export const stepMainFacilitySchema = () =>
  Yup.object<StepMainFacilityForm>().shape({
    mainFacility: Yup.mixed().nullable().required('Povinné pole'),
  });
